import { StepLayout } from 'components/StepLayout/StepLayout';
import { useStoreSetup } from 'hooks/useStoreSetup';
import React, { FC, useCallback } from 'react';
import { StoreSetupStepProgress } from './components/StoreSetupStepProgress';
import { useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { StoreSetupStepError } from './components/StoreSetupStepError';
import { BI_STEP_NAME } from 'config/bi';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/steps';
import { errorUtils } from 'utils/errors';

export const StoreSetupStep: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const { isSuccess, isError, refetch } = useStoreSetup({
    onError: (error) => {
      const errorMessage = errorUtils.getMessage(error);
      biEvents.errorState({
        screen: BI_STEP_NAME[StepId.StoreSetup],
        data: errorMessage,
      });
    },
  });

  const renderContent = useCallback(() => {
    if (isError) {
      return <StoreSetupStepError onTryAgain={refetch} />;
    }

    return <StoreSetupStepProgress shouldComplete={isSuccess} onComplete={next} />;
  }, [isError, isSuccess, refetch, next]);

  return (
    <StepLayout
      hideActions
      disclaimer={t('store-setup-step.disclaimer')}
      description={t('store-setup-step.progress.description')}
      title={t('store-setup-step.progress.title')}
    >
      {renderContent()}
    </StepLayout>
  );
};
